<script lang="ts">
	import { handleInvalidInputs } from "./handleInvalidInputs.js";

	export let form: HTMLFormElement | null = null;
	export let id = "";
	export let antiSpamInputName: string | undefined = "comment";
	export let onsubmit: ((event: SubmitEvent) => void) | undefined = undefined;

	let formClass = "";
	export { formClass as class };

	function handleAntispamSubmit(event: SubmitEvent): void {
		event.preventDefault();

		if (!antiSpamInputName) {
			onsubmit?.(event);
			return;
		}
		if (!(event.currentTarget instanceof HTMLFormElement)) {
			return;
		}
		const data = new FormData(event.currentTarget);
		const antiSpam = data.get(antiSpamInputName) as string;
		if (antiSpam.length > 0) {
			return;
		}
		onsubmit?.(event);
	}
</script>

<form
	bind:this={form}
	class={formClass}
	{id}
	on:submit={handleAntispamSubmit}
	use:handleInvalidInputs
	on:change
	on:input
>
	<slot />

	{#if antiSpamInputName}
		<input type="text" name={antiSpamInputName} id={antiSpamInputName} class="hidden" />
	{/if}
</form>
